import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import type { RouteObject } from "react-router-dom";

const agentNameBreadcrumbSlot = breadcrumbSlot();
const agentVersionBreadcrumbSlot = breadcrumbSlot();
const threadBreadcrumbSlot = breadcrumbSlot();

export const agentRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Agents" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => false} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AgentsPage } = await import("../pages/agents/agents-page");
          return { Component: AgentsPage };
        },
      },
      {
        path: "prompts",
        handle: { breadcrumb: "Edit prompts" },
        async lazy() {
          const { EditPromptsPage } = await import(
            "../pages/edit-prompts/edit-prompts-page"
          );
          return { Component: EditPromptsPage };
        },
      },
      {
        path: "merchant-support",
        handle: { breadcrumb: "Merchant Support" },
        async lazy() {
          const { MerchantSupportDashboard } = await import(
            "../pages/merchant-support/merchant-support-dashboard"
          );
          return { Component: MerchantSupportDashboard };
        },
      },
      {
        path: "ai-ops",
        handle: { breadcrumb: "AI Ops" },
        async lazy() {
          const { AiOpsDashboard } = await import(
            "../pages/ai-ops/ai-ops-dashboard"
          );
          return { Component: AiOpsDashboard };
        },
      },
      {
        path: ":agentName",
        handle: { breadcrumb: agentNameBreadcrumbSlot },
        children: [
          {
            index: true,
            async lazy() {
              const { AgentOverviewPage } = await import(
                "../pages/agent-overview/agent-overview-page"
              );
              return {
                element: (
                  <AgentOverviewPage
                    agentNameBreadcrumbSlot={agentNameBreadcrumbSlot}
                  />
                ),
              };
            },
          },
          {
            path: ":versionedAgentId",
            handle: { breadcrumb: agentVersionBreadcrumbSlot },
            children: [
              {
                index: true,
                async lazy() {
                  const { AgentVersionPage } = await import(
                    "../pages/agent-version/agent-version-page"
                  );
                  return {
                    element: (
                      <AgentVersionPage
                        agentNameBreadcrumbSlot={agentNameBreadcrumbSlot}
                        agentVersionBreadcrumbSlot={agentVersionBreadcrumbSlot}
                      />
                    ),
                  };
                },
              },
              {
                path: "threads/:threadId",
                handle: { breadcrumb: threadBreadcrumbSlot },
                async lazy() {
                  const { ThreadDetailPage } = await import(
                    "../pages/thread-detail/thread-detail-page"
                  );
                  return {
                    element: (
                      <ThreadDetailPage
                        agentNameBreadcrumbSlot={agentNameBreadcrumbSlot}
                        agentVersionBreadcrumbSlot={agentVersionBreadcrumbSlot}
                        threadBreadcrumbSlot={threadBreadcrumbSlot}
                      />
                    ),
                  };
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
